import { array, mixed, number, object, string } from "yup";

import {
  MIN_SECONDARY_RESIDENCE_LIABILITY_ADDRESS_LENGTH,
  MAX_SECONDARY_RESIDENCE_LIABILITY_ADDRESS_LENGTH,
} from "@covertree/consts";
import {
  InputMaybe,
  PersonalProperty,
  PersonalPropertyType,
  SavePolicyLevelExtraCoveragesInput,
  SaveUnitLevelExtraCoveragesInput,
} from "@covertree/new-business-graphql";

export type ExtraCoveragesForm = Omit<
  SavePolicyLevelExtraCoveragesInput,
  "scheduledPersonalProperty"
> & {
  scheduledPersonalProperty?: InputMaybe<
    Array<PersonalProperty & { id: string; price?: number }>
  >;
  identityFraud?: InputMaybe<boolean | Record<string, unknown>>;
} & Partial<SaveUnitLevelExtraCoveragesInput["coverages"]>;

export const scheduledPersonalPropertyValidation = object<PersonalProperty>({
  description: string()
    .required("Description is required")
    .max(250, "Item name is too long"),
  fieldGroupLocator: string().optional(),
  type: mixed<PersonalPropertyType>()
    .required("Type is required")
    .oneOf(Object.values(PersonalPropertyType), "Choose valid type"),
  value: number()
    .positive("Value should be positive")
    .typeError("Value is required")
    .required("Value is required"),
}).required();

export const mineSubsidenceScheduledValidation = object({
  description: string()
    .required("Description is required")
    .max(50, "Structure description is too long"),
  locator: string().optional(),
  value: number()
    .positive("Value should be positive")
    .max(1000000, "Value is too high")
    .typeError("Value is required")
    .required("Value is required"),
}).required();

export const secondaryResidenceLiabilityValidation = array()
  .of(
    object({
      address: string()
        .min(
          MIN_SECONDARY_RESIDENCE_LIABILITY_ADDRESS_LENGTH,
          "Address is too short"
        )
        .max(
          MAX_SECONDARY_RESIDENCE_LIABILITY_ADDRESS_LENGTH,
          "Address is too long"
        )
        .required("Address is required"),
      fieldGroupLocator: string().optional(),
    }).required()
  )
  .optional();

export const extraCoveragesFormValidation = object<ExtraCoveragesForm>({
  secondaryResidenceLiability: secondaryResidenceLiabilityValidation,
});
